import { render, staticRenderFns } from "./WritingOffComissionEarlyPolicyTermination.vue?vue&type=template&id=bb2a34bc&"
import script from "./WritingOffComissionEarlyPolicyTermination.vue?vue&type=script&lang=js&"
export * from "./WritingOffComissionEarlyPolicyTermination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports